import { updateMonthSelectWithFullyear } from "../common/common"
import { formatData } from "../common/FetchFilterData"
import FilterBase from "../common/FilterBase"

const filterEventName = "waitOverviewSpiderFilterSubmit"
const url =
    "https://app.vantetider.se/spa/1.1/rest/filters/filterchoices/availabilityfilter"
class waitOverviewFilter extends FilterBase {
    constructor() {
        super()
        const firstDivName = "firstDiv"
        const secondDivName = "secondDiv"
        const selectorConfig = [
            {
                header: "Välj region(er)",
                name: "regionSelect",
                multiple: true,
                divName: firstDivName,
                attributes: {
                    defaultLabel: "Alla regioner"
                }
            },
            {
                header: "Välj år",
                name: "yearSelect",
                divName: firstDivName,
                startDown: true,
                events: [
                    {
                        name: "change",
                        callback: updateMonthSelectWithFullyear.bind(this)
                    }
                ]
            },
            {
                header: "Välj månad",
                name: "monthSelect",
                divName: secondDivName,
                startDown: true
            }
        ]

        this.addSelectors(selectorConfig)
        this.addSubmitButton({
            text: "Visa Statistik",
            divName: secondDivName,
            submitName: filterEventName,
            valueCallback: this.getSelectorValues.bind(this),
            textCallback: this.getSelectorTexts.bind(this)
        })
        this.addClearFilterButton({
            text: "Rensa",
            divName: secondDivName
        })
        this.getFilterData()

        this.addSearchRequestListener("cwsSearchReq")
    }

    //Used in the constructor for initial load
    async getFilterData() {
        try {
            const res = await formatData({}, url)
            res.regions.unshift({
                name: "Alla regioner",
                value: -1
            })
            res.dates.months.unshift({
                name: "Helår",
                value: "Helår"
            })
            this.addDataToSelect("yearSelect", res.dates.years)
            this.addDataToSelect("monthSelect", res.dates.months)
            this.addDataToSelect("regionSelect", res.regions)
            this.storedData = res
            this.dispatchSubmitEvent(
                filterEventName,
                this.getSelectorValues.bind(this),
                this.getSelectorTexts.bind(this)
            )
            // })
        } catch (err) {
            console.error(err)
            this.errorNoData()
        }
    }

    getSelectorValues() {
        return {
            regionIds: this.getSelectValue("regionSelect"),
            measurementMonth: this.getSelectValue("monthSelect"),
            measurementYear: this.getSelectValue("yearSelect")
        }
    }
    getSelectorTexts() {
        return {
            month: this.getSelectText("monthSelect"),
            year: this.getSelectText("yearSelect"),
            regions: this.getSelectText("regionSelect")
        }
    }
}

if (!customElements.get("wait-overview-filter")) {
    FilterBase.define("wait-overview-filter", waitOverviewFilter)
}
